

<div class="disciplines" [class.required]="required">
  @if (!disciplinesSelection.selected.length && required) {
    <p class="alert alert-danger">
      <strong>{{ 'front.dossiers.fieldGenerator.disciplinesV2.devezSelectionnerMoinsDiscipline' | translate }}.</strong>
    </p>
  }


  <div
    class="disciplines-counter"
    [class.no-value]="disciplinesSelection.selected.length === 0"
    [class.max-reached]="disciplinesSelection.selected.length === max"
    >
    <span>{{disciplinesSelection.selected.length}}/{{ max }}</span>
  </div>

  <div class="disciplines-wrapper" [class.disabled]="disciplinesSelection.selected.length >= max">
    @for (disciplinesGroup of allDisciplines; track disciplinesGroup) {
      <div class="disciplines-group">
        <span class="disciplines-group-label">{{ this.translationService.getTranslation(disciplinesGroup)?.label }}</span>
        <ul>
          @for (discipline of filterChildren(disciplinesGroup.children); track discipline) {
            <li
              [ngClass]="{'selected': disciplinesSelection.isSelected(discipline)}"
              (click)="toggleSelection(discipline)"
              >
              @if (!disciplinesSelection.isSelected(discipline)) {
                <mat-icon>check_box_outline_blank</mat-icon>
              }
              @if (disciplinesSelection.isSelected(discipline)) {
                <mat-icon>check_box</mat-icon>
              }
              <span>{{ this.translationService.getTranslation(discipline)?.label }}</span>
            </li>
          }
        </ul>
      </div>
    }
  </div>
</div>
